import React, { useState, useEffect, useContext, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Button, Icon, Grid, Dropdown } from 'semantic-ui-react'
import Swal from 'sweetalert2'
import styles from './alert-mgmt.module.css'
import IntelMsg from '../ItelMsg'
import { GetUserCustomers } from '../../services/asset'
import { GetCustomerTemplates } from '../../services/configuration-template'
import { history } from '../../redux/store'
import TemplateTable from './template-table'
import { AlertContext } from './alertContext'
import { setCustomerData } from '../../redux/actions/asset'

const AlertMgmt = () => {
  const { setCustomerId } = useContext(AlertContext)
  const { userEmail } = useSelector((store) => ({
    userEmail: store.auth.userEmail,
  }))
  const productName = localStorage.getItem('product')
  const [customersList, setCustomersList] = useState([])
  const [templates, setTemplates] = useState([])
  const [search, setSearch] = useState('')
  const [selectedCustomer, setSelectedCustomer] = useState(
    localStorage.getItem('customer'),
  )
  const dispatch = useDispatch()

  useEffect(() => {
    ;(async () => {
      GetUserCustomers(userEmail, 'cold').then((customers) => {
        const customerData = []
        customers.forEach((customer) => {
          console.log('cust', customer)
          customerData.push({
            text: customer.title,
            value: customer.tbCustomerId,
          })
        })
        setCustomersList(customerData)
      })
      if (selectedCustomer && selectedCustomer !== 'undefined') {
        const queryParams = {
          customerId: selectedCustomer,
        }
        Swal.showLoading()
        const res = await GetCustomerTemplates(queryParams)
        if (res.success) {
          Swal.close()
          console.log('temps: ', res)
          setTemplates(res.data)
        } else {
          Swal.fire('Error Grabing Templates', '', 'error')
        }
      }
    })()
  }, [])

  useEffect(() => {
    setSelectedCustomer(localStorage.getItem('customer'))
    if (customersList.length > 0) {
      const cust = customersList.filter(
        (el) => el.value === localStorage.getItem('customer'),
      )
      console.log('cccs', cust.text)
    }
  }, [localStorage.getItem('customer')])

  const handleChange = async (e, data) => {
    console.log('customerId', data.value)
    const queryParams = {
      customerId: data.value,
    }
    setCustomerId(data.value)
    setSearch('')
    Swal.showLoading()
    const res = await GetCustomerTemplates(queryParams)
    if (res.success) {
      Swal.close()
      console.log('temps: ', res)
      setTemplates(res.data)
    } else {
      Swal.fire('Error Grabing Templates', '', 'error')
    }
  }

  const handleSearch = async (e) => {
    const searchText = e.target.value
    setSearch(searchText)
  }

  const templateData = useMemo(() => {
    if (search === '') return templates
    return templates.filter((temp) => temp['template name'].includes(search))
  }, [search, selectedCustomer, templates])

  return (
    <>
      <Grid columns={3}>
        <Grid.Row>
          <Grid.Column width={2}>
            <b>Select Customer:</b>
          </Grid.Column>
          <Grid.Column>
            <Dropdown
              placeholder="You have to select Customer"
              fluid
              search
              selection
              options={customersList}
              value={selectedCustomer || ''}
              style={{
                marginBottom: '2rem',
                borderColor: '#000',
                borderRadius: '0',
              }}
              onChange={(e, data) => {
                handleChange(e, data)
                setSelectedCustomer(data.value)
                dispatch(setCustomerData(data.value))
                localStorage.setItem('customer', data.value)
              }}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>

      <Grid columns={3}>
        <Grid.Row>
          <Grid.Column width={2}>
            <b>Search:</b>
          </Grid.Column>
          <Grid.Column>
            <input
              style={{
                width: 358,
                height: 40,
                border: '1px solid',
                outline: 'none',
              }}
              placeholder="Search for a template with name"
              value={search}
              onChange={handleSearch}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>

      <br />

      <div className={styles.container}>Configuration Templates</div>

      <TemplateTable templates={templateData} />

      <div>
        <Button
          form="customerSettings"
          type="submit"
          style={{ backgroundColor: '#303d54', color: 'white' }}
          onClick={() => {
            if (productName === 'tank') history.push('/Tank')
            else history.push('/cold')
          }}
        >
          <Icon name="arrow left" />
          <IntelMsg id="back" />
        </Button>
      </div>
    </>
  )
}

export default AlertMgmt
